import { useQuery, useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

export interface FiltroSalvo {
  idFiltro: string;
  nomeFiltro: string;
  idSubEtapaFunil365?: string | null;
  dataCriacaoFiltro?: string | null;
  ordenarPorRecentes?: boolean | null;
  dataCriacaoInicio?: string | null;
  dataCriacaoFim?: string | null;
  dataAtualizacaoInicio?: string | null;
  dataAtualizacaoFim?: string | null;
  recebidosPorTransferencia?: boolean | null;
  dataTransferenciaInicio?: string | null;
  dataTransferenciaFim?: string | null;
  identificaCliente?: boolean | null;
  visitou?: boolean | null;
  idsOrigem?: string[] | null;
  idsCanalContato?: string[] | null;
  idsEtapas?: string[] | null;
  idsSubetapas?: string[] | null;
  idsEtiquetas?: string[] | null;
  farois?: number[] | null;
  idsTemperaturasLead?: string[] | null;
  idsRendaFamiliares?: string[] | null;
  idsEmpreendimentos?: string[] | null;
  semEmpreendimentoInteresse?: boolean | null;
  idsTipoEmpreendimentos?: string[] | null;
  quantidadesDormitorios?: number[] | null;
  idsZonasEmpreendimentos?: string[] | null;
  idsBairrosEmpreendimentos?: string[] | null;
  valorImovelInicio?: string | null;
  valorImovelFim?: string | null;
  idsObjetivosCompra?: string[] | null;
  idsPrazosEntrega?: string[] | null;
  idsMotivosDesqualificacao?: string[] | null;
  somenteLeadsBolsao?: boolean | null;
  idsEquipes?: string[] | null;
  idsCorretores?: string[] | null;
}

// 1. GET - Listar filtros salvos
export function useFiltrosSalvos() {
  const fetchData = async () => {
    const url = `${leadsWebEnviroment}/common/leads/carteira/filtros/corretor/v1`;
    const response = await instance.get(url);
    const raw = response?.data?.data?.filtrosSalvos;
    if (Array.isArray(raw)) return raw as FiltroSalvo[];
    return [] as FiltroSalvo[];
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["filtros-salvos-carteira"],
    refetchOnWindowFocus: false,
  });

  return query;
}

// 2. POST - Criar ou alterar um filtro
// Para criar: enviar nomeFiltro + filtros (opcional)
// Para alterar: enviar idFiltro + filtros + nomeFiltro (caso queira alterar)
export function useCriarFiltro() {
  const mutation = useMutation({
    mutationFn: async (body: Record<string, any>) => {
      const url = `${leadsWebEnviroment}/common/leads/carteira/filtros/v1`;
      const response = await instance.post(url, body);
      return response?.data;
    },
    onError: (error: any) => {
      toast?.error(
        `Erro ao salvar filtro. ${
          error?.response?.data?.notifications?.map(
            (item: any) => item?.message ?? ""
          ) ?? ""
        }`,
        { autoClose: 5000 }
      );
    },
  });

  return mutation;
}

// 3. DELETE - Excluir um filtro
export function useExcluirFiltro() {
  const mutation = useMutation({
    mutationFn: async (idFiltro: string) => {
      const url = `${leadsWebEnviroment}/common/leads/carteira/filtros/v1/${idFiltro}`;
      const response = await instance.delete(url);
      return response?.data;
    },
    onError: (error: any) => {
      toast?.error(
        `Erro ao excluir filtro. ${
          error?.response?.data?.notifications?.map(
            (item: any) => item?.message ?? ""
          ) ?? ""
        }`,
        { autoClose: 5000 }
      );
    },
  });

  return mutation;
}
